import { Component, Input } from '@angular/core';

import { BackLinkInterface } from '~/checkout/interfaces/back-link.interface';

@Component({
  selector: 'app-attendee-dynamic-page-layout',
  templateUrl: './dynamic-page-layout.component.html',
})
export class AttendeeDynamicPageLayoutComponent {
  @Input() public backLink?: BackLinkInterface;
  @Input() public backLinkAriaLabel?: string;

  public get contentContainerClass(): string {
    return this.backLink && 'lg:col-start-2 lg:col-span-11';
  }
}
